/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SkeletonElementsModule} from 'skeleton-elements/angular';

import {FileService} from '../files/file.service';
import {FilesModule} from '../files/files.module';
import {ModalModule} from '../modal/modal.module';
import {MvelModule} from '../mvel/mvel.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';
import {EmployeeSelectModule} from '../employee-select/employee-select.module';

import {AskForSignaturePopupComponent} from './ask-for-signature-popup/ask-for-signature-popup.component';
import {DocumentsListComponent} from './documents-list/documents-list.component';
import {DocumentsService} from './documents.service';
import {SignatureMethodModule} from './signature/signature-method.module';
import {ViewDocumentSidePanelComponent} from './view-document-side-panel/view-document-side-panel.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiModule,
    TranslateModule,
    PipesModule,
    UserModule,
    ModalModule,
    FilesModule,
    MvelModule,
    SkeletonElementsModule,
    EmployeeSelectModule,
    SignatureMethodModule
  ],
  declarations: [
    AskForSignaturePopupComponent,
    DocumentsListComponent,
    ViewDocumentSidePanelComponent
  ],
  exports: [
    AskForSignaturePopupComponent,
    DocumentsListComponent,
    ViewDocumentSidePanelComponent
  ],
  providers: [
    FileService
  ]
})
export class DocumentsModule {
  public static forRoot(): ModuleWithProviders<DocumentsModule> {
    return {
      ngModule: DocumentsModule,
      providers: [
        DocumentsService
      ]
    };
  }
}
